import React, { useContext } from 'react';
import styled from 'styled-components';
import CartItemPriceDisplay from '@components/cart/CartItemPriceDisplay';
import CartItemImage from '@components/cart/ProductImage';
import RemoveFromCart from '@components/cart/RemoveFromCart';
import { Context } from '@components/Context';
import Colors from '@components/shared/Colors';
import FadeIn from '@components/shared/FadeIn';
import { GiftCardCartItem, ProductCode } from '@contracts';
import { getProductTitle } from '@data/products';

interface Props {
  giftCard: GiftCardCartItem;
}

const GiftCardCartItemRow: React.FC<Props> = ({ giftCard }) => {
  const { state } = useContext(Context);
  const { currency } = state;
  const priceText = `${currency.symbol}${giftCard.price?.toFixed(2)}`;

  return (
    <Container>
      <FadeIn duration={400}>
        <CartItemImage id={ProductCode.GiftCard} />
        <CartItemInfo>
          <CartItemTitle>
            <ProductText>
              <span>{getProductTitle(ProductCode.GiftCard)}</span>
              <span className="subtitle">{giftCard.details.recipient.name}</span>
            </ProductText>
          </CartItemTitle>
          <CartItemPriceDisplay
            price={priceText}
            textColor={Colors.navyBlue}
            removeButtonComponent={<RemoveFromCart item={giftCard} editable={true} />}
          />
        </CartItemInfo>
      </FadeIn>
    </Container>
  );
};

export default GiftCardCartItemRow;

const Container = styled.div`
  padding: 30px 0 0;
  margin-top: 15px;

  &:first-child {
    margin-top: 0;
  }

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

const CartItemInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const CartItemTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
`;

const ProductText = styled.h5`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 22px;
  font-weight: normal;
  font-family: 'BrownStd';
  color: ${Colors.navyBlue};

  .subtitle {
    font-size: 13px;
    line-height: 16px;
    opacity: 0.5;

    &:empty {
      display: none;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
